/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HealthBasicsQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type HealthBasicsQuery = { __typename?: 'Query', healthBasics: { __typename?: 'HealthBasics', id: string, heightInInches: number | null, weight: number | null, historyOfTobaccoUse: boolean | null, usedInPastYear: boolean | null, planningToBeOrPregnant: boolean | null, suspendedConviction: boolean | null, dwiConviction: boolean | null, asthma: boolean | null, backProblems: boolean | null, basalCellSkinCancer: boolean | null, cancer: boolean | null, carpalTunnel: boolean | null, copd: boolean | null, depression: boolean | null, diabetes: boolean | null, emphysema: boolean | null, epilepsy: boolean | null, glaucoma: boolean | null, headachesOrMigraines: boolean | null, heartDisease: boolean | null, highBloodPressure: boolean | null, highCholesterol: boolean | null, kidneyOrLiverDisease: boolean | null, kneeInjuryOrSurgery: boolean | null, mentalIllness: boolean | null, otherSeriousMedicalConditions: boolean | null, rheumatoidArthritis: boolean | null, sleepApnea: boolean | null, stroke: boolean | null, ulcerativeColitisOrIleitis: boolean | null, vascularDisease: boolean | null, multipleSclerosis: boolean | null, alzheimerDisease: boolean | null, otherHealthIssues: string | null }, currentUser: { __typename?: 'User', id: string, gender: SchemaTypes.Gender | null } };

export type HealthBasicsValuesFragment = { __typename?: 'HealthBasics', id: string, heightInInches: number | null, weight: number | null, historyOfTobaccoUse: boolean | null, usedInPastYear: boolean | null, planningToBeOrPregnant: boolean | null, suspendedConviction: boolean | null, dwiConviction: boolean | null, asthma: boolean | null, backProblems: boolean | null, basalCellSkinCancer: boolean | null, cancer: boolean | null, carpalTunnel: boolean | null, copd: boolean | null, depression: boolean | null, diabetes: boolean | null, emphysema: boolean | null, epilepsy: boolean | null, glaucoma: boolean | null, headachesOrMigraines: boolean | null, heartDisease: boolean | null, highBloodPressure: boolean | null, highCholesterol: boolean | null, kidneyOrLiverDisease: boolean | null, kneeInjuryOrSurgery: boolean | null, mentalIllness: boolean | null, otherSeriousMedicalConditions: boolean | null, rheumatoidArthritis: boolean | null, sleepApnea: boolean | null, stroke: boolean | null, ulcerativeColitisOrIleitis: boolean | null, vascularDisease: boolean | null, multipleSclerosis: boolean | null, alzheimerDisease: boolean | null, otherHealthIssues: string | null };

export const HealthBasicsValuesFragmentDoc = gql`
    fragment HealthBasicsValues on HealthBasics {
  id
  heightInInches
  weight
  historyOfTobaccoUse
  usedInPastYear
  planningToBeOrPregnant
  suspendedConviction
  dwiConviction
  asthma
  backProblems
  basalCellSkinCancer
  cancer
  carpalTunnel
  copd
  depression
  diabetes
  emphysema
  epilepsy
  glaucoma
  headachesOrMigraines
  heartDisease
  highBloodPressure
  highCholesterol
  kidneyOrLiverDisease
  kneeInjuryOrSurgery
  mentalIllness
  otherSeriousMedicalConditions
  rheumatoidArthritis
  sleepApnea
  stroke
  ulcerativeColitisOrIleitis
  vascularDisease
  multipleSclerosis
  alzheimerDisease
  otherHealthIssues
}
    `;
export const HealthBasicsDocument = gql`
    query HealthBasics {
  healthBasics {
    id
    ...HealthBasicsValues
  }
  currentUser {
    id
    gender
  }
}
    ${HealthBasicsValuesFragmentDoc}`;
export function useHealthBasicsQuery(baseOptions?: Apollo.QueryHookOptions<HealthBasicsQuery, HealthBasicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HealthBasicsQuery, HealthBasicsQueryVariables>(HealthBasicsDocument, options);
      }
export function useHealthBasicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthBasicsQuery, HealthBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HealthBasicsQuery, HealthBasicsQueryVariables>(HealthBasicsDocument, options);
        }
export function useHealthBasicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HealthBasicsQuery, HealthBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HealthBasicsQuery, HealthBasicsQueryVariables>(HealthBasicsDocument, options);
        }
export type HealthBasicsQueryHookResult = ReturnType<typeof useHealthBasicsQuery>;
export type HealthBasicsLazyQueryHookResult = ReturnType<typeof useHealthBasicsLazyQuery>;
export type HealthBasicsSuspenseQueryHookResult = ReturnType<typeof useHealthBasicsSuspenseQuery>;
export type HealthBasicsQueryResult = Apollo.QueryResult<HealthBasicsQuery, HealthBasicsQueryVariables>;